import {TRANSFORMERS, LINK, TextMatchTransformer} from '@lexical/markdown'
import {LinkNode, $isLinkNode, $createLinkNode, $isAutoLinkNode} from '@lexical/link'
import {$createTextNode} from 'lexical'
import {ImageTransformer} from './image'
import {mentionTransformer} from './MentionNode'

/**
 * forked from https://github.com/facebook/lexical/blob/main/packages/lexical-markdown/src/MarkdownTransformers.ts
 * to add support for braces in links by escaping them
 */
export const SLINK: TextMatchTransformer = {
  dependencies: [LinkNode],
  export: (node, exportChildren, exportFormat) => {
    if (!$isLinkNode(node) || $isAutoLinkNode(node)) {
      return null
    }
    const title = node.getTitle()
    const textContent = exportChildren(node)
    const url = node.getURL().replace(/\(/g, '%28').replace(/\)/g, '%29') // this is our change, everything else is the same
    const linkContent = title ? `[${textContent}](${url} "${title}")` : `[${textContent}](${url})`
    return linkContent
  },
  importRegExp: /(?:\[(.*?)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
  regExp: /(?:\[(.*?)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
  replace: (textNode, match) => {
    const [, linkText, linkUrl, linkTitle] = match
    const linkNode = $createLinkNode(linkUrl, {title: linkTitle})
    const openBracketAmount = linkText.split('[').length - 1
    const closeBracketAmount = linkText.split(']').length - 1
    let parsedLinkText = linkText
    let outsideLinkText = ''
    if (openBracketAmount < closeBracketAmount) {
      return
    } else if (openBracketAmount > closeBracketAmount) {
      const linkTextParts = linkText.split('[')
      outsideLinkText = '[' + linkTextParts[0]
      parsedLinkText = linkTextParts.slice(1).join('[')
    }
    const linkTextNode = $createTextNode(parsedLinkText)
    linkTextNode.setFormat(textNode.getFormat())
    linkNode.append(linkTextNode)
    textNode.replace(linkNode)

    if (outsideLinkText) {
      linkNode.insertBefore($createTextNode(outsideLinkText))
    }
    return linkTextNode
  },
  trigger: ')',
  type: 'text-match'
}

export const transformers = [mentionTransformer, ImageTransformer, SLINK, ...TRANSFORMERS.filter(t => t != LINK)]
